import { setTargetEntityPropertiesFromSourceEntityArray } from '../siloRelated/setTargetEntityPropertiesFromSourceEntityArray'
import { TeamMember } from './TeamMember'
import type { IOrderOverview, IOrderTeamMember } from '~/types/order/models'

const mn = '[cynqueModules/dataObjects/OrderTeamMember.ts]'

export function OrderTeamMember(o: IOrderTeamMember): IOrderTeamMember {
  const fn = `${mn} OrderTeamMember |`
  if (!o) {
    throw new Error(`${fn} OrderTeamMember called with falsey orderTeamMember`)
  }
  if (!o.teamMember) {
    throw new Error(
      `${fn} OrderTeamMember called with falsey orderTeamMemmber.teamMember`
    )
  }

  const obj = { ...o }

  obj.teamMember = TeamMember(obj.teamMember)
  obj.label = obj.teamMember.label
  return obj
}

// Propagators

export function propagateOrderTeamMemberData({
  overviewData,
}: {
  overviewData: IOrderOverview
}) {
  //
  // embedded functions
  //
  function _propagateFromOrderTeamMembersToOrder({
    mn,
    overviewData,
  }: {
    mn: string
    overviewData: IOrderOverview
  }) {
    const fn = `${mn} _propagateFromOrderTeamMemberToOrder |`
    const { order, orderTeamMembers } = overviewData
    setTargetEntityPropertiesFromSourceEntityArray({
      propertyNames: ['isOwner', 'isAssignedTo'],
      sourceEntityArray: orderTeamMembers,
      sourceEntitySelectItemIdPathString: 'teamMember.id',
      sourceEntitySelectItemLabelPathString: 'teamMember.label',
      targetEntity: order,
    })
    console.debug(`${fn} overviewData after propagation:`, overviewData)
  }
  //
  // execution starts here...
  //
  const fn = `${mn} propagateOrderTeamMemberData |`
  console.debug(`${fn} called`)
  _propagateFromOrderTeamMembersToOrder({
    mn,
    overviewData,
  })
}
